import { render } from "./CrudPlanilhaTrechos.vue?vue&type=template&id=5ca736d5"
import script from "./CrudPlanilhaTrechos.vue?vue&type=script&lang=ts"
export * from "./CrudPlanilhaTrechos.vue?vue&type=script&lang=ts"
script.render = render

export default script